import { useCallback, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useResendInvitationMutation, useUserByIdQuery } from 'api';
import { ADMIN_ROUTES } from 'constants/routes';
import { useNotificationMessages } from 'hooks/useNotificationMessages';

export const useDetails = () => {
  const [drawerState, setDrawerState] = useState<boolean>(false);

  const { id } = useParams() as { id: string };
  const navigate = useNavigate();
  const { handleError, handleSuccess } = useNotificationMessages();
  const { data: userDetails = {} } = useUserByIdQuery({ id });
  const [resendInvitation, { isLoading }] = useResendInvitationMutation();

  const onExpand = useCallback(() => {
    setDrawerState((prevState) => !prevState);
  }, []);

  const onUpdateClick = useCallback(() => {
    navigate(`${ADMIN_ROUTES.users.update}/${id}`);
  }, [navigate, id]);

  const onResendInvitation = useCallback(async () => {
    try {
      const { data, error } = await resendInvitation({ email: userDetails.email });
      if (data?.success) {
        handleSuccess('Invitation successfully resent.');
      } else {
        handleError(error);
      }
    } catch (err) {
      handleError(err);
    }
  }, [userDetails, handleError, handleSuccess, resendInvitation]);

  return {
    onUpdateClick,
    userDetails,
    drawerState,
    onExpand,
    onResendInvitation,
    isLoading,
  };
};
